const testimonialLoader = () => {
	const grid = document.querySelector('.am-for-grid');

	if (!grid) {
		return;
	}

	const resizeGridItems = () => {
		const gridItems = document.querySelectorAll('.archive-testimonial.loading');
		gridItems.forEach((item) => {
			// const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
			// const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));

			const cardHeight = item.querySelector('.review').offsetHeight;

			if (160 < cardHeight) {
				const rowSpan = Math.ceil((cardHeight + 30) / 30);

				// item.style.gridRowEnd = "span "+rowSpan;
				item.style.setProperty('--review-row-end', rowSpan);
			}

			item.classList.remove('loading');
		});
	}

	const loadMore = document.querySelector('#reviews-load-more');

	const observeOptions = {
		rootMargin: '0px 0px 500px 0px',
		threshold: 0
	};

	const observeCall = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				loadMore.click();
				resizeGridItems();
			} else {
				resizeGridItems();
				// setTimeout(() => {
				// 	resizeGridItems();
				// }, 1000);
			}
		});
	};

	const lazyPostObserver = new IntersectionObserver(observeCall, observeOptions);

	const siteFooter = document.querySelector('.site-footer');
	lazyPostObserver.observe(siteFooter);
	window.onload = resizeGridItems();
	window.addEventListener('resize', resizeGridItems);
};

export default testimonialLoader;